import PropTypes from 'prop-types';
import React, { useCallback, useContext, useState } from 'react';
import {
  Button, Col, Form, InputGroup, Row, Spinner,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import LoginContext from '../../../providers/authLoginProvider';
import IconAlert from '../../blanks/common/IconAlert';

function LoginForm({ hasLabel, passwordPost }) {
  // State
  const [formData, setFormData] = useState({
    login: '',
    password: '',
    remember: false,
  });
  const [showPwd, setShowPwd] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);

  const {
    onClearError, loading,
  } = useContext(LoginContext);
  // Handler
  const handleSubmit = useCallback(
    (e) => {
      onClearError();
      e.preventDefault();
      passwordPost({
        username: formData.login,
        password: formData.password,
      })
        .then(() => null)
        .catch((er) => setErrorMsg(er.message));
    },
    [formData.login, formData.password, onClearError, passwordPost],
  );

  const handleFieldChange = useCallback(
    (e) => {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    },
    [formData],
  );

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Користувач</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Користувач' : ''}
          value={formData.login}
          name="login"
          onChange={handleFieldChange}
          type="text"
          autoComplete="username"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Пароль</Form.Label>}
        <InputGroup>
          <Form.Control
            type={showPwd ? 'text' : 'password'}
            placeholder={!hasLabel ? 'Пароль' : ''}
            value={formData.password}
            name="password"
            onChange={handleFieldChange}
            autoComplete="current-password"
          />
          <InputGroup.Text className="p-0">
            <Button
              variant="light"
              onClick={() => setShowPwd((prev) => !prev)}
              className="px-3 py-2 text-muted"
            >
              <FontAwesomeIcon icon={showPwd ? faEyeSlash : faEye} />
            </Button>
          </InputGroup.Text>
        </InputGroup>
      </Form.Group>

      <Row className="justify-content-between align-items-center">
        <Col xs="auto">
          <Link
            className="fs--1 mb-0"
            to="/resetPassword/"
          >
            Забули пароль?
          </Link>
        </Col>
      </Row>

      <Form.Group>
        <Button
          type="submit"
          color="primary"
          className="mt-3 w-100"
          disabled={!formData.login || !formData.password || loading}
        >
          {loading ? (
            <Spinner size="sm" />
          )
            : <span>Увійти</span>}
        </Button>

        <br />
        <br />
        {/* <h5 className="alert-heading"> */}
        {/*  Не маєте облікового запису? */}
        {/*  {' '} */}
        {/*  <Link */}
        {/*    className="text-decoration-underline" */}
        {/*    to="/authentication/card/register" */}
        {/*  > */}
        {/*    Розпочати! */}
        {/*  </Link> */}
        {/* </h5> */}
      </Form.Group>

      {errorMsg && (
      <IconAlert variant="danger" dismissible onClose={onClearError}>
        <p className="mb-0">
          {errorMsg}
        </p>
      </IconAlert>
      )}

    </Form>
  );
}

LoginForm.propTypes = {
  hasLabel: PropTypes.bool,
  passwordPost: PropTypes.func.isRequired,
};

LoginForm.defaultProps = {
  hasLabel: false,
};

export default LoginForm;
